export default "__VITE_ASSET__DPpTnL7Y__"